import { SITE_URL } from '../constants'
import { CasesIndexItem } from '../types'

/** 事例一覧 ItemList。事例追加時はここに1件追加し numberOfItems が自動で同期される */
export const casesIndexItems: CasesIndexItem[] = [
  {
    name: '全3回のUX/UIワークショップで、プロジェクトを前に進める共通言語を獲得',
    url: `${SITE_URL}/cases/jtb-cwt/`,
  },
  {
    name: 'AI時代の開発生産性を支えるデザインシステムを構築',
    url: `${SITE_URL}/cases/aldagram/`,
  },
  {
    name: '海外送金アプリを刷新し、ロイヤルティ向上と改修工数削減を実現',
    url: `${SITE_URL}/cases/remit/`,
  },
  { name: 'アジャイル開発により Webサービスのアプリ化を2か月半で実現', url: `${SITE_URL}/cases/sanu/` },
  {
    name: '課題解決率が大幅向上 - "使える生成AIチャット"をアジャイル×UX/UIでスピード実現',
    url: `${SITE_URL}/cases/dir/`,
  },
  {
    name: '不動産売買の契約業務をDX化 - UX/UI刷新でミスを削減し、作業時間を大幅に短縮',
    url: `${SITE_URL}/cases/nakajitsu/`,
  },
  {
    name: '利用者10％増 - UX/UI改善で転職成功に必須のアプリを開発',
    url: `${SITE_URL}/cases/career-design-center/`,
  },
  {
    name: '新アプリ開発で顧客接点を一元化、グループ会社との連携も強化',
    url: `${SITE_URL}/cases/heart-one/`,
  },
  {
    name: 'UX/UI刷新で顧客離れを防止、若年層にも支持されるミドルウェア設計',
    url: `${SITE_URL}/cases/hulft/`,
  },
  {
    name: '運用工数&コストの削減をデザインシステム導入で実現',
    url: `${SITE_URL}/cases/macromill-designsystem/`,
  },
  { name: 'マニュアル不要の市場調査・分析SaaS開発を実現', url: `${SITE_URL}/cases/coreka/` },
  { name: 'AI搭載アプリ開発で申し込み率改善、引越業務も効率化', url: `${SITE_URL}/cases/gurutto-ai/` },
  { name: '日本初のMaaSアプリ開発で、地方の高齢化に伴う課題の解決に貢献', url: `${SITE_URL}/cases/meemo/` },
  { name: 'CVR107%改善 - システム改修なしでECサイトのUX/UIを最新化', url: `${SITE_URL}/cases/7net/` },
  {
    name: '共済マイページのユーザー数増加、リニューアル後も継続支援',
    url: `${SITE_URL}/cases/kyosaimypage/`,
  },
  { name: '売上約130%上昇 - グローバルECサイト構築で「真のDX」を実現', url: `${SITE_URL}/cases/kaiho/` },
  { name: 'CVR20%向上 - 美容総合メディアのデザインリニューアル', url: `${SITE_URL}/cases/seyfert/` },
  { name: '新築マンションの引越業務効率化をシステム開発で実現', url: `${SITE_URL}/cases/mss/` },
  {
    name: 'NPBスコア分析WebソリューションのBtoC展開をUX/UI設計で支援',
    url: `${SITE_URL}/cases/assistantrobo/`,
  },
  {
    name: 'クラウドネイティブなシステム構築と日本向けUX/UI設計でアプリのローカライズを支援',
    url: `${SITE_URL}/cases/tennispointapp/`,
  },
  { name: '変化し続ける市場の最先端を走るために必須なDX推進を支援', url: `${SITE_URL}/cases/kaneka/` },
  {
    name: 'ユーザーとのコミュニケーション活性化のためのメタバース空間構築',
    url: `${SITE_URL}/cases/nagoyatv/`,
  },
  { name: 'VRコンテンツの開発で災害に関する教育の効率化', url: `${SITE_URL}/cases/volunteer-ex/` },
  { name: 'PEACH JOHN 公式アプリ', url: `${SITE_URL}/cases/peachjohn/` },
  { name: 'ニッセンオンライン', url: `${SITE_URL}/cases/nissen/` },
  { name: 'コンタクトレンズが簡単注文できるアプリ', url: `${SITE_URL}/cases/visionaryholdings/` },
  { name: 'QUICK Global Alert', url: `${SITE_URL}/cases/quick/` },
  { name: '東京スター銀行アプリ', url: `${SITE_URL}/cases/nri/` },
  { name: 'docomo Open Inovation Cloud', url: `${SITE_URL}/cases/ntt/` },
  { name: 'Ultra Caddy', url: `${SITE_URL}/cases/anchor/` },
  { name: 'mirron', url: `${SITE_URL}/cases/mirron/` },
  { name: 'JOB理論1dayワークショップ', url: `${SITE_URL}/cases/ando/` },
  { name: 'イノベーション ワークショップ', url: `${SITE_URL}/cases/kayaba/` },
  { name: 'DX-DAY アイデアソン', url: `${SITE_URL}/cases/jfe/` },
]
